<template>
  <span class="text-ellipsis" :class="{ 'text-ellipsis--inline': inline }" :style="{ '-webkit-line-clamp': rows }">
    <slot />
  </span>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
  props: {
    rows: {
      type: Number,
      required: false,
      default: 1,
    },
    inline: {
      type: Boolean,
      required: false,
      default: false,
    },
    action: {
      type: Function,
      default: null,
    },
  },
  updated() {
    this.callAction()
  },
  methods: {
    callAction() {
      if (this.action) {
        this.action(this)
      }
    },
  },
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/text-ellipsis.scss';
</style>
